import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout'

Vue.use(Router)

const _import = require('./_import_' + process.env.NODE_ENV);
export default {
    path: '/',
    meta: {
      permission: true
    },
    component: Layout,
    children: [
      {
        path: 'question',
        name: 'question',
        component: _import('question/index'),
        meta: {
          permission: true,
          allowBack: false,
          noCache: true
        }
      },
      {
        path: 'pointVideo', // 单视频
        name: 'pointVideo',
        component: _import('pointVideo'),
        meta: {
          permission: true,
          allowBack: false,
          noCache: true
        }
      },
    ]
}


// WEBPACK FOOTER //
// ./src/router/layout.js